var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"x-button x-button-cancel",on:{"click":function($event){$event.preventDefault();return _vm.clickDownload.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }